import type { SVGProps } from 'react';

export const SvgIconCategory210 = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M26.3133 10.1724L22.1133 14.1224L26.1133 25.1224L23.1133 28.1224L17.1383 19.3724L14.1133 22.1224V25.1224L11.1133 28.1224L9.33828 22.8849L4.11328 21.1224L7.11328 18.1224H10.1133L13.1133 15.1224L4.11328 9.12239L7.11328 6.12239L18.1133 10.1224L22.0758 5.93489L21.9883 5.99739C22.5519 5.43381 23.3163 5.11719 24.1133 5.11719C24.9103 5.11719 25.6747 5.43381 26.2383 5.99739C26.8019 6.56098 27.1185 7.32536 27.1185 8.12239C27.1185 8.91942 26.8019 9.68381 26.2383 10.2474L26.3133 10.1724Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
